export const globalConfig = {
  baseUrl: window.__BASEURL__,
  locale: window.__LOCALE__,
  messages: window.__MESSAGES__,
  initialState: window.__INITIAL_STATE__,
  config: window.__CONFIG__,
  experiments: window.__EXPERIMENTS__,
};

export function getInitialCategory() {
  return globalConfig.initialState.category;
}

export function getInitialEmail() {
  return globalConfig.initialState.email;
}

export function getTemplateLang() {
  return globalConfig.initialState.templateLang;
}

export function getSubId() {
  return globalConfig.initialState.subId;
}

export function getInitialStoreName() {
  return globalConfig.initialState.storeName;
}

export function getInitialThemeKey() {
  return globalConfig.initialState.themeKey;
}

export function getUtmParam() {
  return globalConfig.initialState.utmParam;
}
